import { Filter } from "model/Filter/Filter";
import { Header } from "../Header/Header";
import { Tour } from "model/Tour/Tour";

interface Props {
  tour: Tour;
  tabFilter: Filter<string>;
}

export const TourHeader = ({ tour, tabFilter }: Props) => {
  return (
    <Header
      description={tour.description}
      endTime={tour.endTimeMs}
      links={tour.links}
      id={tour.id}
      name={tour.name}
      startTime={tour.startTimeMs}
      tabFilter={tabFilter}
      type="Tour"
      theme={tour.theme}
    />
  );
};
